/**
 * Created by Jerker Nord on 2018-12-04.
 */
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {ITextStyles} from "./ITextStyles";

export class ThorMobileTextStyles implements ITextStyles {

    private static _instance:ThorMobileTextStyles = new ThorMobileTextStyles();

    static get instance():ThorMobileTextStyles {
        return this._instance;
    }

    constructor() {
        if(ThorMobileTextStyles._instance) {
            throw new Error("Error: ThorMobileTextStyles.constructor() - Instantiation failed: Use ThorMobileTextStyles.instance instead of new.");
        }
    }

    COUNTUP_YELLOW_BITMAP_STYLE:BitmapTextStyleOptions = {
        font : {
            name : "thorCountUp",
            size : 30
        },
        tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    COUNTUP_BLUE_BITMAP_STYLE:BitmapTextStyleOptions = {
        font : {
            name : "thorCountUpBlue",
            size : 30
        },
        tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    // Bitmap font for number of FS in main game
    FS_WIN_NUMBER:BitmapTextStyleOptions = {
        font : {
            name : "thorCountUp",
            size : 9
        }
    };

    MULTIPLIER_TEXT_STYLE:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : "50px",
        fill : "#FFFFFF",
        stroke : "#000000",
        strokeThickness : 2
    };

    SCATTER_COUNTER_TEXT_STYLE:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : "120px",
        fill : "#FFFFFF",
        stroke : "#000000",
        strokeThickness : 2
    };

    FREESPIN_INTRO_YOU_WON:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : "50px",
        fill : "#e4e1c8",
        fontStyle : FontStyle.NORMAL,
        fontWeight : FontWeight.BOLD,
        dropShadow : true,
        dropShadowAlpha : 1,
        dropShadowAngle : Math.PI * 0.5,
        dropShadowBlur : 8,
        dropShadowColor : "#000000",
        dropShadowDistance : 3,
        padding : 20
    };

    FREESPIN_INTRO_NUMBER:BitmapTextStyleOptions = {
        font : {
            name : "thorCountUp",
            size : 50
        }
    };


    FREESPIN_OUTRO_YOU_WON:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : "50px",
        fill : "#e4e1c8",
        fontStyle : FontStyle.NORMAL,
        fontWeight : FontWeight.BOLD,
        dropShadow : true,
        dropShadowAlpha : 1,
        dropShadowAngle : Math.PI * 0.5,
        dropShadowBlur : 8,
        dropShadowColor : "#000000",
        dropShadowDistance : 3,
        padding : 20
    };

    FREESPIN_OUTRO_NUMBER:BitmapTextStyleOptions = {
        font : {
            name : "thorCountUp",
            size : 15
        }
    };

    FREESPIN_OUTRO_SPINS_PLAYED:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : "30px",
        fill : "#e4e1c8",
        fontStyle : FontStyle.NORMAL,
        fontWeight : FontWeight.BOLD,
        dropShadow : true,
        dropShadowAlpha : 1,
        dropShadowAngle : Math.PI * 0.5,
        dropShadowBlur : 8,
        dropShadowColor : "#000000",
        dropShadowDistance : 3,
        padding : 20
    };


}